export default __webpack_public_path__ + "8b321e542d0c02043e907195b9a478bf.png";